import { RequirementModel } from '@abb-procure/data';
import {
  CdkDrag,
  CdkDragDrop,
  CdkDropList,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import {
  Component,
  Input,
  OnInit,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Card } from '../card/card.component';

@Component({
  selector: 'requirements-fields-sorting-group',
  templateUrl: './requirements-fields-sorting-group.component.html',
  styleUrl: './requirements-fields-sorting-group.component.scss',
  imports: [CdkDropList, CdkDrag, MatIcon, Card],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class RequirementFieldsSortingGroup implements OnInit {
  @Input() requirements!: RequirementModel[];
  @Input() customSelected?: RequirementModel[];
  @Input() formFields?: { [key: string]: string };

  readonly selectedChanged = output<RequirementModel[]>();

  selected: RequirementModel[] = [];
  unselected: RequirementModel[] = [];

  ngOnInit(): void {
    if (this.customSelected) {
      this.selected = [...this.customSelected].sort(
        (a, b) => a.orderIndex - b.orderIndex,
      );

      this.unselected = this.requirements.filter(
        (item) =>
          !this.customSelected?.find((selected) => selected.name === item.name),
      );
    } else {
      this.unselected = [...this.requirements];
    }
  }

  getTitle(name: string | null): string {
    return name && this.formFields ? this.formFields[name] : '';
  }

  drop(
    event: CdkDragDrop<RequirementModel[] | []>,
    isSelected: boolean = false,
  ): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }

    this.updateRequirements(
      isSelected ? event.container.data : event.previousContainer.data,
    );
  }

  updateRequirements(data: RequirementModel[] | []): void {
    const orderedData = data.map((item, index) => ({
      ...item,
      orderIndex: index,
    }));
    this.selectedChanged.emit(orderedData);
  }
}
